import { MeetingListSearchQuery, MeetingListSearchType, PaginationQuery } from "@api";
import { meetingsState } from "./types";

const initinalPaginationQuery = new PaginationQuery({
	descendingOrder: true,
	currentPage: 1,
	pageSize: 9,
});

const initialSearchQuery = new MeetingListSearchQuery({
	quickSearch: '',
	searchType: MeetingListSearchType.Quick,
	participants: [],
	statuses: [],
	subject: '',
	taskUri: '',
	transcript: '',
	startDateUtc_Start: null,
	startDateUtc_End: null,
	startTimeUtc_Start: null,
	startTimeUtc_End: null,
});

const initinalState: meetingsState = {
	scrollPosition: 0,
	query: initialSearchQuery,
	paginationQuery: initinalPaginationQuery,
	showOrganizations: false,
};

export {
	initinalPaginationQuery,
	initinalState,
};